import React from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * PageHeader — Componente oficial do Design System NetUno.
 * Uso obrigatório para cabeçalhos de páginas internas.
 * Proibido criar headers manuais fora deste componente.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  className,
}) => (
  <div className={cn('flex items-center justify-between flex-wrap gap-3 flex-shrink-0', className)}>
    <div>
      <h2 className="text-[22px] font-semibold text-foreground font-display leading-tight">{title}</h2>
      {subtitle && (
        <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
